export default __webpack_public_path__ + "static/media/icon-s-gear.f93c83aa.svg";